const ProductStructureCardSkeleton = () => {
  return (
    <div className="structure-card-shadow py-4 px-5 rounded-[20px] max-w-[444px]">
      {/* Card header skeleton */}
      <div>
        {/* Title skeleton */}
        <div className="h-6 bg-gray-200 rounded w-40 mb-5 animate-pulse"></div>

        {/* Engagement metric skeleton */}
        <div className="bg-gray-100 rounded-[10px] py-1.5 px-2 inline-flex items-center animate-pulse">
          <div className="w-3 h-3 bg-gray-300 rounded mr-1"></div>
          <div className="h-3 bg-gray-300 rounded w-20"></div>
        </div>
      </div>

      {/* Hook body cta skeleton */}
      <div className="my-5">
        <div className="flex gap-x-2">
          {[1, 2, 3].map((item) => (
            <div
              key={item}
              className="py-1 px-2 rounded-[4px] bg-gray-200 animate-pulse"
            >
              <div className="h-5 w-12 bg-gray-300 rounded"></div>
            </div>
          ))}
        </div>

        {/* Description skeleton */}
        <div className="mt-3">
          <div className="h-4 bg-gray-200 rounded w-full mb-1 animate-pulse"></div>
          <div className="h-4 bg-gray-200 rounded w-3/4 animate-pulse"></div>
        </div>
      </div>

      {/* Similar structure skeleton */}
      <div className="bg-[#FDFDFD] border border-[#DDDDDD] py-3 px-[18px] rounded-lg mb-3">
        <div className="mb-3 flex items-center gap-x-10 justify-between">
          <div className="h-4 bg-gray-200 rounded w-48 animate-pulse"></div>
          <div className="h-7 bg-gray-200 rounded-[8px] w-20 animate-pulse"></div>
        </div>

        <div className="grid grid-cols-2 gap-x-[31px] w-full overflow-x-auto">
          {[1, 2].map((index) => (
            <div key={index} className="w-full min-w-[120px] flex-shrink-0">
              {/* Video thumbnail skeleton */}
              <div className="h-[122px] bg-gray-200 rounded-[8px] animate-pulse"></div>

              {/* Video info skeleton */}
              <div className="border border-[#F2F2F2] rounded-[8px] py-1 w-full mt-2.5 space-y-1">
                <div className="h-3 bg-gray-200 rounded w-16 mx-auto animate-pulse"></div>
                <div className="h-2 bg-gray-200 rounded w-12 mx-auto animate-pulse"></div>
                <div className="h-2 bg-gray-200 rounded w-20 mx-auto animate-pulse"></div>
                <div className="h-2 bg-gray-200 rounded w-14 mx-auto animate-pulse"></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Action button skeleton */}
      <div className="h-12 bg-gray-200 rounded-[12px] w-full animate-pulse"></div>
    </div>
  );
};

export default ProductStructureCardSkeleton;
